import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@material-ui/core";

import "./GenericModal.scss";

export default class GenericModal extends React.Component {
  render() {
    const { open, onClose } = this.props;

    return (
      <Modal className="genericModal" open={open} onClose={onClose}>
        <div className="modalContainer">{this.props.children}</div>
      </Modal>
    );
  }
}

GenericModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};
